import { render, staticRenderFns } from "./InstructionPackagesList.vue?vue&type=template&id=79571797&scoped=true"
import script from "./InstructionPackagesList.vue?vue&type=script&lang=js"
export * from "./InstructionPackagesList.vue?vue&type=script&lang=js"
import style0 from "./InstructionPackagesList.vue?vue&type=style&index=0&id=79571797&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79571797",
  null
  
)

export default component.exports